// The OG Cart V3 — Theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      hamburger.textContent = mobileNav.classList.contains('open') ? '✕' : '☰';
    });
  }
  // Sticky header shadow
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 16px rgba(0,0,0,0.07)' : 'none';
    });
  }
  // Cart qty buttons
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(0, val - 1);
      if (this.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });
  // Product gallery thumbs
  document.querySelectorAll('.product-gallery-thumbs img').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const main = document.getElementById('mainImg');
      if (main) main.src = this.dataset.full || this.src;
      document.querySelectorAll('.product-gallery-thumbs img').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
});
function adjustQty(btn, delta) {
  const input = btn.parentElement.querySelector('input[type="number"]');
  if (input) input.value = Math.max(0, parseInt(input.value || 0) + delta);
}
